import { render, staticRenderFns } from "./FormPreview.vue?vue&type=template&id=27f79a72&scoped=true"
import script from "./FormPreview.vue?vue&type=script&lang=js"
export * from "./FormPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f79a72",
  null
  
)

export default component.exports